module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBoldItalic.a8c8285.ttf";